import {callService, POST} from "./serviceInvoker";
import {trackingURL} from "./urls/clientapi";
import {hit_type_pageview, site_identifier, hit_type_event} from "../constants/index"
import {appendIfNotEmptyOrNull} from "./utils"

export function trackPageView(page_name) {    
    let bodyFormData = new FormData();
    bodyFormData.append('hit_type', hit_type_pageview);
    bodyFormData.append('site_identifier', site_identifier);
    bodyFormData = appendIfNotEmptyOrNull('page_name', page_name, bodyFormData)
    if (sessionStorage.getItem('user_id') !== '') {
        bodyFormData.append('user', sessionStorage.getItem('user_id'));
    }
    if (sessionStorage.getItem('contact_id') !== '') {
        bodyFormData.append('contact', sessionStorage.getItem('contact_id'));
    }
    if (sessionStorage.getItem('isImpersonating') !== '') {
        bodyFormData.append('is_impersonating', sessionStorage.getItem('isImpersonating'));
    }

    callService(
        POST,
        trackingURL,
        bodyFormData,
        response => {},
        error => {}
      );
}

export function trackEvent(event_category, event_action, event_label, event_value, page_name) {    
    let bodyFormData = new FormData();
    bodyFormData.append('hit_type', hit_type_event);
    bodyFormData.append('site_identifier', site_identifier);
    bodyFormData = appendIfNotEmptyOrNull('event_category', event_category, bodyFormData)
    bodyFormData = appendIfNotEmptyOrNull('event_action', event_action, bodyFormData)
    bodyFormData = appendIfNotEmptyOrNull('event_label', event_label, bodyFormData)
    bodyFormData = appendIfNotEmptyOrNull('event_value', event_value, bodyFormData)
    bodyFormData = appendIfNotEmptyOrNull('page_name', page_name, bodyFormData)
    if (sessionStorage.getItem('user_id') !== '') {
        bodyFormData.append('user', sessionStorage.getItem('user_id'));
    }
    if (sessionStorage.getItem('contact_id') !== '') {
        bodyFormData.append('contact', sessionStorage.getItem('contact_id'));
    }
    if (sessionStorage.getItem('isImpersonating') !== '') {
        bodyFormData.append('is_impersonating', sessionStorage.getItem('isImpersonating'));
    }

    callService(
        POST,
        trackingURL,
        bodyFormData,
        response => {},
        error => {}
      );
}


// WEBPACK FOOTER //
// ./src/shared/tracking.js